import React from "react";
import actions from "../actions";
import BusinessForm from "../businessForm";
import Panel from "common/components/Panel";
import { transformApiError } from "common/api/errors";

async function handleSubmit(values, form, providersData) {
  const {
    address,
    city,
    community,
    building,
    category,
    country,
    name,
    postal,
    website,
    phone,
    region,
    hours,
    heroFile,
    logoFile,
    keywords,
    active,
    description,
    tenant_id,
  } = values;
  const { setSubmitting, setErrors, setStatus, resetForm } = form;
  try {
    const body = {
      street_address: address,
      city,
      community_id: community,
      category_id: category,
      primary_phone_number: phone,
      website_url: website,
      hours: JSON.stringify(hours || {}),
      country,
      name,
      postal_code: postal,
      region,
      keywords,
      active,
      description,
      food_links: providersData,
      tenant_id,
    };
    if (building) {
      body.building_id = building;
    }
    const business = await actions.create(body);
    form.resetForm();

    await actions.attachFiles(business.id, [
      {
        prop: "hero_url",
        name: "hero",
        file: heroFile,
      },
      {
        prop: "logo_url",
        name: "logo",
        file: logoFile,
      },
    ]);

    resetForm();
    setStatus({ success: true });
  } catch (error) {
    const apiError = transformApiError(error);
    if (apiError.empty()) {
      setErrors({ http: error.message });
    } else {
      setErrors(apiError.object());
    }
  }
  setSubmitting(false);
}

const initialValues = {
  name: "",
  address: "",
  city: "",
  website: "",
  phone: "",
  region: "",
  country: "",
  postal: "",
  community: "",
  building: "",
  category: "",
  hours: {},
  keywords: "",
  description: "",
  active: false,
  tenant_id: 0,
};

const CreateBusiness = () => (
  <Panel title="Create Business">
    <BusinessForm handleSubmit={handleSubmit} initialValues={initialValues} />
  </Panel>
);

export default CreateBusiness;
